import {Button, Form, Stack } from "react-bootstrap";
import axiosInstance from "../api";
import {toast} from "react-toastify";
import {processPdfResponse} from "../helpers/file-helper";
import {useState} from "react";

export const DownloadPdfCard = ({candidateId, vacancyIds = []}: { candidateId: number, vacancyIds?: number[] }) => {
  const [includeAllResumes, setIncludeAllResumes] = useState(true);
  const [action, setAction] = useState<"download" | "print">("download");

  const handleAction = async () => {
    if (action === "download") {
      if (includeAllResumes) {
        return await getAll()
      }

      return await handleDownload()
    }
    if (action === "print") {
      if (includeAllResumes) {
        return await getAll(includeAllResumes)
      }

      return await handlePrint()
    }
  };


  const getCardPDF = () => {
    return axiosInstance.post(
      `/api/candidate/getCardPDF/${candidateId}`,
      {vacancyIds},
      {responseType: "blob", headers: {Accept: "application/pdf"}}
    );
  }
  const getFullCandidate = () => {
    return axiosInstance.post(
      `/api/candidate/getFullCandidate/${candidateId}`,
      {vacancyIds},
      { responseType: "blob" } // Получаем бинарные данные
    );
  }

  const handleDownload = async () => {
    try {

      const response = await getCardPDF()
      const contentDisposition = response.headers["content-disposition"];
      let filename = "карточка.pdf";

      if (contentDisposition) {
        const utf8Match = contentDisposition.match(/filename\*=UTF-8''(.+?)(?:;|$)/);
        if (utf8Match) {
          filename = decodeURIComponent(utf8Match[1]);
        } else {
          const match = contentDisposition.match(/filename="?(.+?)"?(?:;|$)/);
          if (match) {
            filename = match[1];
          }
        }
      }
      console.log("Download pdf");
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Ошибка при загрузке PDF:", error);
    }
  };

  const handlePrint = async () => {
    try {

      const response = await getCardPDF()
      const blob = new Blob([response.data], {type: "application/pdf"});
      const url = window.URL.createObjectURL(blob);

      const printWindow = window.open(url, "_blank");
      if (printWindow) {
        printWindow.onload = () => {
          printWindow.print();
        };
      }
    } catch (error) {
      toast.error("Ошибка при печати карточки");
    }
  };

  const getAll = async (shouldPrint = false) => {
    try {
      const response = await getFullCandidate();
      const contentDisposition = response.headers["content-disposition"];
      processPdfResponse(response.data, contentDisposition, shouldPrint);
    } catch (error) {
      console.error("Ошибка при загрузке файлов:", error);
      toast.error("Ошибка при загрузке файлов");
    }
  };

  return (
    <Stack gap={2} className="p-3 border rounded">
      <Form.Group>
        <Form.Check
          type="checkbox"
          label="Включить резюме"
          checked={includeAllResumes}
          onChange={(e) => setIncludeAllResumes(e.target.checked)}
        />
      </Form.Group>

      <Form.Group>
        <Form.Check
          type="radio"
          label="Скачать PDF"
          name="action"
          checked={action === "download"}
          onChange={() => setAction("download")}
        />
        <Form.Check
          type="radio"
          label="Печать"
          name="action"
          checked={action === "print"}
          onChange={() => setAction("print")}
        />
      </Form.Group>
      <div className={'flex justify-end'}>
        <Button size='sm' onClick={handleAction} className="mt-2 !w-max ">
          {action === "download" ? "Скачать" : "Распечатать"}
        </Button>
      </div>
    </Stack>
  )
};
